export default "__VITE_ASSET__76cf4cb2__"